var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset190(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.59 128.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f55d4;opacity:0.15;}.cls-2{fill:#fff;}.cls-3{fill:#2f55d4;}.cls-4{fill:#d5dfeb;}.cls-5,.cls-7{fill:#3e6177;}.cls-6,.cls-7{opacity:0.3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 190") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -14.21,
    y: 44.5,
    width: 147,
    height: 50,
    rx: 25,
    ry: 25,
    transform: "translate(-31.78 62.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.91,18l-.09,1.94a8.15,8.15,0,0,0,1.67,5.32l1.18,1.54a8.15,8.15,0,0,1-.47,10.46l-1.31,1.43a8.15,8.15,0,0,0-2.14,5.15l-.09,1.94a8.15,8.15,0,0,1-7.09,7.71l-1.92.25a8.15,8.15,0,0,0-4.95,2.57L68.39,57.7A8.15,8.15,0,0,1,58,59.05l-1.63-1a8.15,8.15,0,0,0-5.44-1.22L49,57a8.15,8.15,0,0,1-8.82-5.64l-.58-1.85a8.15,8.15,0,0,0-3.39-4.43l-1.63-1a8.15,8.15,0,0,1-3.13-10l.74-1.79a8.15,8.15,0,0,0,.25-5.57l-.58-1.85a8.15,8.15,0,0,1,4-9.67l1.72-.89a8.15,8.15,0,0,0,3.77-4.1l.74-1.79a8.15,8.15,0,0,1,9.3-4.82L53.32,4a8.15,8.15,0,0,0,5.53-.72l1.72-.89A8.15,8.15,0,0,1,70.79,4.7L72,6.24a8.15,8.15,0,0,0,4.7,3l1.89.42A8.15,8.15,0,0,1,84.91,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.09,51.79a6.29,6.29,0,1,1,6.29-6.29A6.3,6.3,0,0,1,100.09,51.79Zm0-9.59a3.29,3.29,0,1,0,3.29,3.29A3.3,3.3,0,0,0,100.09,42.21Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "59.29 60.09 39.89 103.06 35.9 91.81 24.81 96.25 42.32 56.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "59.83 60.09 79.22 103.06 83.22 91.81 94.31 96.25 74.91 53.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.32,22.47l-.06,1.27a5.33,5.33,0,0,0,1.09,3.48l.77,1a5.33,5.33,0,0,1-.31,6.84L76,36a5.33,5.33,0,0,0-1.4,3.36l-.06,1.27a5.33,5.33,0,0,1-4.63,5l-1.26.16a5.33,5.33,0,0,0-3.23,1.68l-.86.93a5.33,5.33,0,0,1-6.79.88l-1.07-.68a5.33,5.33,0,0,0-3.56-.79L51.84,48a5.33,5.33,0,0,1-5.77-3.69l-.38-1.21a5.33,5.33,0,0,0-2.21-2.89l-1.07-.68a5.33,5.33,0,0,1-2-6.53l.49-1.17A5.33,5.33,0,0,0,41,28.18L40.64,27a5.33,5.33,0,0,1,2.63-6.32l1.13-.58a5.33,5.33,0,0,0,2.47-2.68l.49-1.17a5.33,5.33,0,0,1,6.08-3.15l1.24.28a5.33,5.33,0,0,0,3.61-.47l1.13-.58a5.33,5.33,0,0,1,6.68,1.49l.77,1a5.33,5.33,0,0,0,3.07,2l1.24.28A5.33,5.33,0,0,1,75.32,22.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "39.73 107.08 35.01 93.78 21.97 99.01 40.94 55.52 43.69 56.72 27.65 93.5 36.79 89.83 40.06 99.05 57.92 59.48 60.66 60.71 39.73 107.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "79.39 107.08 58.46 60.71 61.19 59.48 79.06 99.05 82.33 89.83 91.41 93.47 73.54 53.9 76.27 52.67 97.2 99.03 84.11 93.78 79.39 107.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.39,61.84a9.62,9.62,0,0,1-5.2-1.52l-1.63-1a6.67,6.67,0,0,0-4.44-1l-1.92.25a9.64,9.64,0,0,1-10.45-6.68L37.17,50a6.66,6.66,0,0,0-2.76-3.61l-1.63-1a9.63,9.63,0,0,1-3.71-11.83l.74-1.79A6.66,6.66,0,0,0,30,27.18l-.58-1.85A9.63,9.63,0,0,1,34.2,13.88L35.92,13A6.66,6.66,0,0,0,39,9.64l.74-1.79a9.63,9.63,0,0,1,11-5.71l1.89.42A6.65,6.65,0,0,0,57.15,2l1.72-.89A9.63,9.63,0,0,1,71,3.79l1.18,1.54A6.65,6.65,0,0,0,76,7.78l1.89.42a9.63,9.63,0,0,1,7.53,9.85L85.32,20a6.65,6.65,0,0,0,1.36,4.34l1.18,1.54a9.63,9.63,0,0,1-.56,12.39L86,39.69a6.66,6.66,0,0,0-1.75,4.2l-.09,1.94a9.63,9.63,0,0,1-8.39,9.13l-1.92.25a6.65,6.65,0,0,0-4,2.09l-1.31,1.43A9.63,9.63,0,0,1,61.39,61.84ZM51,55.23a9.66,9.66,0,0,1,5.2,1.52l1.63,1a6.64,6.64,0,0,0,8.47-1.1l1.31-1.43a9.66,9.66,0,0,1,5.86-3L75.37,52a6.64,6.64,0,0,0,5.78-6.29l.09-1.94a9.66,9.66,0,0,1,2.54-6.09l1.31-1.43a6.64,6.64,0,0,0,.39-8.54L84.3,26.15a9.65,9.65,0,0,1-2-6.3l.09-1.94a6.64,6.64,0,0,0-5.19-6.79l-1.89-.42a9.66,9.66,0,0,1-5.56-3.55L68.6,5.61a6.64,6.64,0,0,0-8.34-1.86l-1.72.89A9.67,9.67,0,0,1,52,5.49L50.1,5.07A6.64,6.64,0,0,0,42.51,9l-.74,1.79a9.66,9.66,0,0,1-4.47,4.86l-1.72.89a6.64,6.64,0,0,0-3.28,7.89l.58,1.85a9.67,9.67,0,0,1-.3,6.59l-.74,1.79a6.64,6.64,0,0,0,2.56,8.15l1.63,1a9.67,9.67,0,0,1,4,5.24L40.61,51a6.64,6.64,0,0,0,7.2,4.6l1.92-.25A9.61,9.61,0,0,1,51,55.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.59,51.66a6.81,6.81,0,0,1-3.68-1.08l-1.07-.68a3.85,3.85,0,0,0-2.55-.57L52,49.49a6.82,6.82,0,0,1-7.39-4.73l-.38-1.21a3.83,3.83,0,0,0-1.59-2.08l-1.07-.68A6.82,6.82,0,0,1,39,32.42l.49-1.17a3.83,3.83,0,0,0,.12-2.61l-.38-1.21a6.82,6.82,0,0,1,3.37-8.1l1.13-.58a3.84,3.84,0,0,0,1.77-1.93L46,15.64a6.81,6.81,0,0,1,7.79-4l1.24.28a3.83,3.83,0,0,0,2.6-.34L58.71,11a6.82,6.82,0,0,1,8.56,1.91l.77,1a3.84,3.84,0,0,0,2.21,1.41l1.24.28a6.82,6.82,0,0,1,5.33,7h0l-.06,1.27a3.84,3.84,0,0,0,.78,2.5l.77,1a6.82,6.82,0,0,1-.4,8.77l-.86.93a3.83,3.83,0,0,0-1,2.42L76,40.69a6.82,6.82,0,0,1-5.94,6.46l-1.26.16a3.83,3.83,0,0,0-2.32,1.21l-.86.93A6.82,6.82,0,0,1,60.59,51.66ZM53.78,46.3a6.84,6.84,0,0,1,3.68,1.08l1.07.68a3.82,3.82,0,0,0,4.88-.63l.86-.93a6.84,6.84,0,0,1,4.15-2.15l1.26-.16A3.82,3.82,0,0,0,73,40.55l.06-1.27A6.83,6.83,0,0,1,74.85,35l.86-.93a3.82,3.82,0,0,0,.22-4.91l-.77-1a6.83,6.83,0,0,1-1.4-4.46l.06-1.27a3.82,3.82,0,0,0-3-3.91l-1.24-.28a6.84,6.84,0,0,1-3.93-2.52l-.77-1a3.82,3.82,0,0,0-4.8-1.07L59,14.2a6.83,6.83,0,0,1-4.63.6l-1.24-.28a3.83,3.83,0,0,0-4.37,2.26L48.24,18a6.84,6.84,0,0,1-3.16,3.44L44,22a3.82,3.82,0,0,0-1.89,4.54l.38,1.21a6.84,6.84,0,0,1-.21,4.66l-.49,1.17a3.82,3.82,0,0,0,1.47,4.69l1.07.68a6.84,6.84,0,0,1,2.84,3.71l.38,1.21a3.83,3.83,0,0,0,4.14,2.65l1.26-.16A6.78,6.78,0,0,1,53.78,46.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20.63,86.16a6.84,6.84,0,1,1,6.84-6.84A6.85,6.85,0,0,1,20.63,86.16Zm0-10.68a3.84,3.84,0,1,0,3.84,3.84A3.84,3.84,0,0,0,20.63,75.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 52.93,
    cy: 97.17,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 32.64,
    cy: 5.34,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 92.44,
    cy: 18.15,
    r: 2.94
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 48.23,
    y: 25.46,
    width: 14.73,
    height: 3,
    transform: "translate(-2.24 48.71) rotate(-46.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 55.95,
    y: 28.93,
    width: 9.45,
    height: 3,
    transform: "translate(-2.84 54.37) rotate(-47.29)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.39,
    y: 68.19,
    width: 14.95,
    height: 2,
    transform: "translate(-35 83.78) rotate(-65.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.31,
    y: 79.83,
    width: 6.41,
    height: 2,
    transform: "translate(-48.69 85.7) rotate(-65.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.77,
    y: 85.65,
    width: 2.14,
    height: 2,
    transform: "translate(-55.54 86.61) rotate(-65.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.32,
    y: 88.09,
    width: 2,
    height: 12.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.32,
    y: 102.59,
    width: 2,
    height: 5.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.32,
    y: 109.84,
    width: 2,
    height: 1.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 89.62,
    cy: 86.16,
    r: 26.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 90.53,
    cy: 86.16,
    r: 21.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.62,108.89a22.73,22.73,0,1,1,22.73-22.73A22.76,22.76,0,0,1,89.62,108.89Zm0-42.47a19.73,19.73,0,1,0,19.73,19.73A19.76,19.76,0,0,0,89.62,66.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.7,95.64a1.92,1.92,0,0,1-1.1-.35l-7.67-5.37a1.5,1.5,0,0,1,1.72-2.46l6.81,4.77L98.59,77.39a1.5,1.5,0,1,1,2.4,1.8L89.24,94.86A1.92,1.92,0,0,1,87.7,95.64Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset190);
export default __webpack_public_path__ + "static/media/Asset190.03ec0a06513fd2489cd3618ebd66d0d6.svg";
export { ForwardRef as ReactComponent };